import io from "socket.io-client";
import { socketUrl } from "../../config";

async function socketNotification(eventName, eventData) {
  const secure = socketUrl && socketUrl.startsWith("https://");
  const socket = io(socketUrl, {
    secure,
    transports: ["websocket"],
    reconnection: false,
    forceNew: true,
    rejectUnauthorized: false,
    autoConnect: true,
  });

  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      if (!socket.connected) {
        socket.removeAllListeners();
        socket.disconnect();
        reject(new Error("Connection timeout"));
      }
    }, 5000); // bisa diubah kalau perlu

    socket.on("connect", () => {
      try {
        if (eventName && eventData) {
          socket.emit(eventName, eventData);
        }
        clearTimeout(timeout);
        resolve(); // ✅ resolve langsung setelah emit
        socket.disconnect(); // tutup koneksi setelah kirim
      } catch (err) {
        clearTimeout(timeout);
        reject(err);
      }
    });

    socket.on("connect_error", (error) => {
      clearTimeout(timeout);
      socket.removeAllListeners();
      socket.disconnect();
      reject(error);
    });
  });
}

export default socketNotification;
